var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-full-empty"},[_c('img',{attrs:{"src":_vm.emptySvg || _vm.NON_DATA,"alt":""}}),_c('div',[_vm._v(_vm._s(_vm.emptyText || _vm.$t('enterprise.no-data')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }